import { useContext } from "react"
import { RootStore } from "../stores/RootStore"
import { RootStoreContext } from "../context/RootStoreContext"
export function useRootStore(): RootStore {

    const rootStore = useContext(RootStoreContext)
    if (rootStore === undefined) {
        throw new Error("useRootStore hook must be used within a RootStoreContext.Provider")
    }

    return rootStore
}
